(function (global) {

  /**
  * Некоторые значение в localStorage устаревают от версии к версии. здесь можно 
  * их очистить.
  */
  var clearOldCache = function (oldVersion, newVersion) {
    log.info('MIGRATION', 'Removing some items from localStorage');

    WA.cache.removeItem('themes/light.css');
    WA.cache.removeItem('themes/dark.css');

  };

  global.handlers.push(clearOldCache);

})(Core.migration);